export function withFallback(c, fallback) {
    return {
        encode: c.encode,
        decode: (terse) => {
            try {
                return c.decode(terse);
            }
            catch (err) {
                return fallback;
            }
        },
    };
}
//# sourceMappingURL=algebra.js.map